(() => {
  const initialise = () => {
    document.querySelectorAll('[data-article-related-reading]').forEach((block) => {
      if (block.dataset.analyticsInitialised === 'true') return;
      block.dataset.analyticsInitialised = 'true';

      block.addEventListener('click', (event) => {
        const link = event.target.closest('[data-article-related-reading-link]');
        if (!link || !block.contains(link)) return;

        const payload = {
          article_id: block.dataset.articleId || '',
          article_handle: block.dataset.articleHandle || '',
          article_title: block.dataset.articleTitle || '',
          article_url: window.location.pathname,
          page_location: window.location.href,
          placement: link.dataset.articlePlacement || 'article_end',
          destination_title: link.dataset.destinationTitle || link.textContent.trim(),
          destination_url: link.getAttribute('href') || '',
        };
        if (typeof window.tcgkingTrackArticleEvent === 'function') {
          window.tcgkingTrackArticleEvent('article_related_click', payload);
        }
        if (!window.Shopify?.analytics?.publish) return;

        try {
          const result = window.Shopify.analytics.publish('tcgking:article_related_click', payload);
          if (result?.catch) result.catch(() => {});
        } catch (_error) {
          // Analytics must never interrupt navigation.
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();
